/** IMMO MATCH design-tokens — 1-op-1 overgenomen uit property-finder-744 src/theme.ts
 *  plus de demo-shell kleuren uit app-demo.tsx / IcebergExperience.tsx. */
export const C = {
  navy: '#102A43',
  navyDeep: '#0A1A2C',
  navySoft: '#1B3A5C',
  gold: '#C48A3A',
  goldSoft: '#E9C88A',
  sand: '#F7F5F2',
  sandDark: '#EDE7DD',
  bgSoft: '#EEF3F9',
  bgSoftDark: '#DDE6F0',
  green: '#22C55E',
  greenSoft: '#DCFCE7',
  white: '#FFFFFF',
  ink: '#0F1B2D',
  inkMuted: '#5B6B7F',
  inkFaint: '#94A2B4',
  line: '#E6E1DA',
  danger: '#B3261E',
  // demo-shells (exacte hex uit app-demo.tsx / IcebergExperience.tsx)
  demoNavy: '#0e2340',
  demoNavyDeep: '#050a14',
  demoGold: '#c48a3a',
  creme: '#f5eee1',
  water: '#38a3d1',
  waterDeep: '#1a5a7a',
};

export const FONT = "'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";
